'use client';

import { styled } from '@linaria/react';
import { useSpring } from 'react-spring';

import { normalize, roundTo } from '@/utils';

import Demo, {
  DemoOutputWrapper,
  DemoSliderControl,
} from '@/components/Demo';
import Code from './Code';
import Box from './Box';

function DesignDistanceDemo({ variant }) {
  return (
    <Demo
      id={variant}
      outputWrapper={DesignDistanceOutputWrapper}
      initialValues={{
        distance: 0.5,
      }}
      controls={[
        <DemoSliderControl
          key="distance"
          id="distance"
          label="Elevation"
          min={0}
          max={1}
          step={0.01}
        />,
      ]}
    >
      {({ distance }) => {
        return <DesignDistance distance={distance} />;
      }}
    </Demo>
  );
}

function DesignDistance({ distance }) {
  const blurRadius = roundTo(normalize(distance, 0, 1, 0, 16), 1);
  const offsetX = roundTo(normalize(distance, 0, 1, 0, 8), 1);
  const offsetY = roundTo(normalize(distance, 0, 1, 0, 16), 1);
  const opacity = roundTo(normalize(distance, 0, 1, 0.5, 0.25), 2);
  const scale = normalize(distance, 0, 1, 1, 1.1);

  const boxShadow = `${offsetX.toFixed(1)}px ${offsetY.toFixed(
    1
  )}px ${blurRadius.toFixed(1)}px hsl(0deg 0% 0% / ${opacity.toFixed(
    2
  )})`;

  const styles = useSpring({
    transform: `scale(${scale})`,
    boxShadow,
  });

  return (
    <Wrapper>
      <Foreground style={styles}></Foreground>
      <Code>box-shadow: {boxShadow};</Code>
    </Wrapper>
  );
}

const DesignDistanceOutputWrapper = styled(DemoOutputWrapper)`
  background-color: hsl(285deg 90% 90%);
  padding: 50px 0px 32px 0px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  width: 100%;
`;

const Foreground = styled(Box)`
  border-radius: 6px;
  will-change: transform;
`;

export default DesignDistanceDemo;
